<template>
  <div>
    <div class="EventResource-title">
      <div>{{ $t("RAM.AWS.Event.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:aws:event:export']"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="EventResource-top">
      <event-resource-search
        ref="eventResourceSearchChild"
      ></event-resource-search>
    </div>
    <table-event-resource></table-event-resource>
  </div>
</template>

<script>
import EventResourceSearch from "../event/EventResourceSearch";
import TableEventResource from "../event/TableEventResource";

export default {
  name: "EventResource",
  components: {
    EventResourceSearch,
    TableEventResource
  },
  data() {
    return {
      modal_loading: false,
      accountIds: [],
      resourceType: "",
      companyId: "",
      timeList: [],
      eventTypes: []
    };
  },
  methods: {
    //导出
    exportList: function() {
      // 获取子组件数据
      this.companyId = this.$refs.eventResourceSearchChild.companyId;
      this.accountIds = this.$refs.eventResourceSearchChild.accountIds;
      this.resourceType = this.$refs.eventResourceSearchChild.resourceType;
      this.eventTypes = this.$refs.eventResourceSearchChild.eventTypes;
      this.timeList = this.$refs.eventResourceSearchChild.timeList;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.event
        .export({
          companyId: this.companyId,
          timeList: this.timeList,
          accountIds: this.accountIds,
          resourceType: this.resourceType,
          eventTypes: this.eventTypes
        })
        .then(res => {
          let fileName = this.$t('RAM.export.eventRecord');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.EventResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.EventResource-title > div:nth-child(1) {
  float: left;
}
.EventResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.EventResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/event/EventResource.vue